import { SelectOption } from "../../select/EnhancedSelect";
import {
  COMPANY_CONTRACT_TYPE_LABELS,
  COMPANY_CONTRACT_TYPE_VALUES,
  COMPANY_PAYMENT_TERMS_LABELS,
  COMPANY_PAYMENT_TERMS_VALUES,
} from "@/lib/constants/company-commercial-terms";

// Contact Status Options
export const CONTACT_STATUS_OPTIONS: SelectOption[] = [
  { value: "lead", label: "Lead" },
  { value: "prospect", label: "Prospect" },
  { value: "customer", label: "Customer" },
  { value: "churned", label: "Churned" },
  { value: "inactive", label: "Inactive" },
  { value: "personal", label: "Personal" },
  { value: "system_notification", label: "System/Notification" },
  { value: "other_non_revenue", label: "Other (Non-Revenue)" },
];

// Contract Type Options — values come from `COMPANY_CONTRACT_TYPE_VALUES`
// (single source of truth shared with the Meridian/MCP company tools).
export const CONTRACT_TYPE_OPTIONS: SelectOption[] = COMPANY_CONTRACT_TYPE_VALUES.map(
  (value) => ({ value, label: COMPANY_CONTRACT_TYPE_LABELS[value] })
);

// Industry Options
export const INDUSTRY_OPTIONS: SelectOption[] = [
  { value: "technology", label: "Technology" },
  { value: "healthcare", label: "Healthcare" },
  { value: "finance", label: "Finance" },
  { value: "education", label: "Education" },
  { value: "retail", label: "Retail" },
  { value: "manufacturing", label: "Manufacturing" },
  { value: "consulting", label: "Consulting" },
  { value: "legal", label: "Legal" },
  { value: "real_estate", label: "Real Estate" },
  { value: "nonprofit", label: "Nonprofit" },
  { value: "home_service_work", label: "Home Service Work" },
  { value: "commercial_service", label: "Commercial Service" },
  { value: "general_construction", label: "General Construction" },
  { value: "business_association", label: "Business Association" },
  { value: "city_government", label: "City Government" },
  { value: "chamber_of_commerce", label: "Chamber of Commerce" },
  { value: "home_construction", label: "Home Construction" },
  { value: "commercial_real_estate", label: "Commercial Real Estate" },
  { value: "other", label: "Other" },
];

// Source Options
export const SOURCE_OPTIONS: SelectOption[] = [
  { value: "website", label: "Website" },
  { value: "referral", label: "Referral" },
  { value: "social_media", label: "Social Media" },
  { value: "cold_call", label: "Cold Call" },
  { value: "trade_show", label: "Trade Show" },
  { value: "advertising", label: "Advertising" },
  { value: "other", label: "Other" },
];

// Lifecycle Stage Options
export const LIFECYCLE_STAGE_OPTIONS: SelectOption[] = [
  { value: "new_lead", label: "New Lead" },
  { value: "qualified_lead", label: "Qualified Lead" },
  { value: "proposal_sent", label: "Proposal Sent" },
  { value: "negotiation", label: "Negotiation" },
  { value: "customer", label: "Customer" },
  { value: "churned", label: "Churned" },
];

// Payment Terms Options — values come from `COMPANY_PAYMENT_TERMS_VALUES`
// (single source of truth shared with the Meridian/MCP company tools).
export const PAYMENT_TERMS_OPTIONS: SelectOption[] = COMPANY_PAYMENT_TERMS_VALUES.map(
  (value) => ({ value, label: COMPANY_PAYMENT_TERMS_LABELS[value] })
);
